import React from 'react'
import { ListGroup } from 'react-bootstrap'

const pinImg = require('../../../static/images/pushpin.png')

const Notifications = (props) => {
  return (
    <ListGroup>
      {props.notifications.map(notification => {
        const active = props.currentNotification && props.currentNotification.url === notification.url

        const notificationClass = notification.is_read ? 'notification-list-item' : 'notification-list-item unread'

        return (
          <ListGroup.Item
            active={active}
            key={notification.url}
            className={notificationClass}
            onClick={() => props.setCurrentNotification(notification, props)}
          >
            {notification.is_read ?
              null
              :
              <div className='unread-marker'></div>
            }

            {notification.name}

            {notification.is_pinned ?
              <img src={pinImg} alt="pin" className='pin-image' />
              :
              null
            }
          </ListGroup.Item>
        )
      }
      )}
    </ListGroup>
  )
}

export default Notifications
